import api from "@/api";
import { PaginationModel } from "./types";

export default class ConfirmApi {
  static async list(
    options:
      | {
          filter?: {
            role?: string[];
          };
        }
      | PaginationModel
  ) {
    return await api.get(`gene/apply/list`, options);
  }

  static async confirm(id: string) {
    return await api.post(`confirm/${id}`);
  }

  static async status(memberCode:any, status:any) {
    return await api.post(`gene/apply/changeGeneStatus/${memberCode}/${status}`);
  }
}
